export default function findQuestionByRefId(arr, refId) {
  let match;

  arr.forEach((question) => {
    if (match) return;

    if (question.refId === refId) {
      match = question;
      return;
    }

    if (question.questions && !match) {
      match = findQuestionByRefId(question.questions, refId);
    }
  });

  return match;
}
